import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Preloader from "./preloader.svg";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Switch = /*#__PURE__*/function (_Component) {
  _inherits(Switch, _Component);
  var _super = _createSuper(Switch);
  function Switch() {
    var _this;
    _classCallCheck(this, Switch);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(event);
    });
    return _this;
  }
  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultChecked = _this$props.defaultChecked,
        isLoading = _this$props.isLoading,
        className = _this$props.className,
        children = _this$props.children,
        disabled = _this$props.disabled,
        isFuture = _this$props.isFuture,
        checked = _this$props.checked,
        name = _this$props.name;
      var id = "checkbox__".concat(name);
      return /*#__PURE__*/React.createElement("div", {
        className: cx('component', className, {
          disabled: disabled,
          isLoading: isLoading,
          isFuture: isFuture
        }),
        "data-t-id": "components-Switch"
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('switch')
      }, /*#__PURE__*/React.createElement("input", {
        checked: checked,
        className: cx('absolute', 'input'),
        "data-component": "Switch",
        defaultChecked: defaultChecked,
        disabled: disabled,
        id: id,
        name: name,
        onChange: this.handleChange,
        type: "checkbox"
      }), /*#__PURE__*/React.createElement("span", {
        className: cx('absolute', 'back')
      }), (isFuture || isLoading) && /*#__PURE__*/React.createElement("div", {
        className: cx('absolute', 'preloaderContainer', checked && 'active')
      }, /*#__PURE__*/React.createElement(Preloader, {
        className: cx('preloader')
      })), /*#__PURE__*/React.createElement("span", {
        className: cx('circle')
      })), children && /*#__PURE__*/React.createElement("label", {
        className: cx('label'),
        htmlFor: id
      }, children));
    }
  }]);
  return Switch;
}(Component);
_defineProperty(Switch, "defaultProps", {
  defaultChecked: false
});
_defineProperty(Switch, "defaultProps", {
  onChange: function onChange() {}
});
export { Switch as default };
Switch.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Определяет начальное состояние атрибута, помечен ли заранее элемент */
  defaultChecked: PropTypes.bool,
  /** Определяет состояние прелоадера: активен/не активен */
  isLoading: PropTypes.bool,
  /** Блокирует переключение состояния компонента */
  disabled: PropTypes.bool,
  /** Параметр для добавления дополнительных классов */
  className: PropTypes.any,
  /** Определяет состояние прелоадера: активен/не активен */
  isFuture: PropTypes.bool,
  /** Callback */
  onChange: PropTypes.func,
  /** Любой обьект или строка */
  children: PropTypes.any,
  /** Определяет состояние атрибута: активен/не активен */
  checked: PropTypes.bool,
  /** Имя переключателя */
  name: PropTypes.string
} : {};